import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { computed, observable } from "mobx";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import UiMeet3dLayoutWrapper from "~/modules/UiMeet3d/components/UiMeet3dLayoutWrapper";
import UiMeet3dNav from "~/modules/UiMeet3d/constants/UiMeet3dNav";
import SubscriptionPageStore from "~/stores/Subscription/SubscriptionPageStore";
import RouteWrapper from "~/components/wrapper/RouteWrapper";
import ProviderStatisticStore from "~/stores/Provider/ProviderStatisticStore";
import CustomerStatisticStore from "~/stores/Customer/CustomerStatisticStore";
import ProviderStore from "~/stores/Provider/ProviderStore";
import CustomerStore from "~/stores/CustomerStore";
import Immersive3dTourPanelUiMeet3dHomeContent from "~/applications/immersive_3d_tour_panel/components/Immersive3dTourPanelUiMeet3dHomeContent";
import PanelUiMeet3dHomeContent from "~/applications/panel/components/PanelUiMeet3dHomeContent";

@observer
class UiMeet3dHomePage extends Component {
  ref = null;

  @observable subscriptionPageStore = null;

  @observable providerStatisticStore = null;

  @observable customerStatisticStore = null;

  constructor(props) {
    super(props);

    const { t } = props;

    this.ref = createRef();
    document.title = `${t("uiMeet3d")} - ${t("home")}`;

    this.subscriptionPageStore = new SubscriptionPageStore();
    this.providerStatisticStore = new ProviderStatisticStore();
    this.customerStatisticStore = new CustomerStatisticStore();
  }

  componentDidMount() {
    const { showError, actualUserStore } = this.props;
    const { actualUser } = actualUserStore;
    const { subscriptionStore, otherProductStore } = this.subscriptionPageStore;

    subscriptionStore
      .loadIndex()
      .then(() => {
        const { activeSubscriptions } = subscriptionStore;

        const subscription = activeSubscriptions.length > 0 ? activeSubscriptions[0] : null;

        if (!subscription) {
          return;
        }

        const modules = ["uiMeet3dSecondsTotal", "uiMeet3dLeadsCount", "uiMeet3dEventNotificationsCount"];

        if (actualUserStore instanceof ProviderStore) {
          modules.push("uiMeet3dActiveToursCount");
          this.providerStatisticStore.providerId = actualUser.providerId;
          this.providerStatisticStore
            .load({
              modules,
              from: subscription.currentBillingCycleStartDate.format("YYYY-MM-DD"),
              to: subscription.currentBillingCycleEndDate.format("YYYY-MM-DD"),
            })
            .catch(error => showError(error.message));
        } else {
          modules.push(this.customerStatisticModule);
          this.customerStatisticStore.customerId = actualUser.customerId;
          this.customerStatisticStore
            .load({
              modules,
              from: subscription.currentBillingCycleStartDate.format("YYYY-MM-DD"),
              to: subscription.currentBillingCycleEndDate.format("YYYY-MM-DD"),
            })
            .catch(error => showError(error.message));
        }
      })
      .catch(error => showError(error.message));

    otherProductStore.loadIndex().catch(error => showError(error.message));
  }

  @computed
  get customerStatisticModule() {
    const { actualUserStore } = this.props;
    const { actualUser } = actualUserStore;

    return actualUser.hasUrbanimmersiveGroupSpecialPricing ? "activeToursCount" : "uiMeet3dActiveToursCount";
  }

  render() {
    const { redirectTo, actualUserStore } = this.props;
    const { subscriptionStore, otherProductStore } = this.subscriptionPageStore;
    const { isLoading: actualUserLoading, actualUser } = actualUserStore;
    const { isLoading: subscriptionLoading, activeSubscriptions } = subscriptionStore;
    const { isLoading: otherProductLoading, subscriptionOtherProducts } = otherProductStore;
    const { isLoading: providerStatisticLoading, providerStatistic } = this.providerStatisticStore;
    const { isLoading: customerStatisticLoading, customerStatistic } = this.customerStatisticStore;

    if (
      actualUserLoading ||
      subscriptionLoading ||
      otherProductLoading ||
      providerStatisticLoading ||
      customerStatisticLoading
    ) {
      return <ContentLoader />;
    }

    return (
      <div className="side-page-outer-container" style={{ marginTop: "0" }}>
        {actualUserStore instanceof ProviderStore ? (
          <Immersive3dTourPanelUiMeet3dHomeContent
            actualUser={actualUser}
            subscription={activeSubscriptions.length > 0 ? activeSubscriptions[0] : null}
            otherProducts={subscriptionOtherProducts}
            redirectToGeneralPageCallback={() => redirectTo("/ui-meet-3d/general")}
            redirectToSubscriptionCreatePageCallback={() => redirectTo("/billing-central/subscriptions/create")}
            statistic={providerStatistic}
            statisticModule="uiMeet3dActiveToursCount"
          />
        ) : (
          <PanelUiMeet3dHomeContent
            actualUser={actualUser}
            subscription={activeSubscriptions.length > 0 ? activeSubscriptions[0] : null}
            otherProducts={subscriptionOtherProducts}
            redirectToGeneralPageCallback={() => redirectTo("/ui-meet-3d/general")}
            redirectToSubscriptionCreatePageCallback={() => redirectTo("/billing-central/subscriptions/create")}
            statistic={customerStatistic}
            statisticModule={this.customerStatisticModule}
          />
        )}
      </div>
    );
  }
}

UiMeet3dHomePage.propTypes = {
  actualUserStore: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStore), PropTypes.instanceOf(CustomerStore)]),
  t: PropTypes.func.isRequired,
  redirectTo: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorWrapper(RouteWrapper(UiMeet3dLayoutWrapper(UiMeet3dHomePage, UiMeet3dNav.HOME))));
